<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Materialized Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
                <!-- :disabled-dates="disabledDates" -->
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getMaterializedRecords((isExcel = 'N'))"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
          <!-- <div class="col-lg-8 col-xl-2 align-self-center mb-3">
            <div class="input_material">
              <b-form-input
                type="search"
                @input="onSearch"
                v-model="searchText"
                placeholder="Search Bill No"
              ></b-form-input>
            </div>
          </div> -->

          <div
            v-if="materializedRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getMaterializedRecords((isExcel = 'Y'))"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table border="1" class="swc-report-table w-25 my-3">
          <tr>
            <td class="font-weight-bold bg-lightgrey">Month</td>
            <td class="font-weight-bold bg-lightgrey">Year</td>
          </tr>
          <tr>
            <td>{{ nepalMonth.month }}</td>
            <td>{{ nepalMonth.year }}</td>
          </tr>
        </table>

        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Fiscal Year</th>
            <th>Bill No</th>
            <th>Customer Name</th>
            <th>Customer PAN</th>
            <th>Bill Date</th>
            <th>Amount</th>
            <th>Discount</th>
            <th>Taxable Amount</th>
            <th>Tax Amount</th>
            <th>Total Amount</th>
            <th>Sync with IRD</th>
            <th>Is Printed</th>
            <th>Is Active</th>
            <th>Is Real Time</th>
            <th>Printed Time</th>
            <th>Entered By</th>
            <th>Printed By</th>
            <th>Transaction ID</th>
            <th>Payment Method</th>
            <th>VAT Refund Amount</th>
          </thead>
          <tbody v-if="materializedRecords.length > 0">
            <tr
              v-for="(
                materializedData, materializedIndex
              ) in materializedRecords"
              :key="materializedIndex"
              :class="
                materializedData.refunded_date_time
                  ? 'text-danger'
                  : 'text-dark'
              "
            >
              <td class="text-left">{{ materializedData.fiscal_year }}</td>
              <!-- <td class="text-left">{{ materializedData.bill_no }}</td> -->
              <td class="text-left">
                {{
                  materializedData.refunded_date_time
                    ? materializedData.fnb_refund_bill_no
                      ? `${
                          materializedData.fnb_refund_bill_no
                        }(ref.${removeSRPrefix(materializedData.bill_no)})`
                      : `${
                          materializedData.refund_bill_no
                        }(ref.${removeSRPrefix(materializedData.bill_no)})`
                    : materializedData.bill_no
                }}
              </td>
              <td class="text-left">
                {{
                  materializedData.cust_name ||
                  materializedData.guest_name ||
                  "-"
                }}
              </td>
              <td>
                {{
                  materializedData["cust_pan"]
                    ? materializedData["cust_pan"]
                    : "-"
                }}
              </td>
              <td class="text-left">{{ materializedData.bill_date }}</td>
              <td class="text-right">
                {{
                  !materializedData.refunded_date_time
                    ? currFormat(materializedData.amount)
                    : `-${currFormat(materializedData.amount)}`
                }}
              </td>
              <td class="text-right">
                {{
                  materializedData.discount
                    ? !materializedData.refunded_date_time
                      ? currFormat(materializedData.discount)
                      : `-${currFormat(materializedData.discount)}`
                    : 0
                }}
              </td>
              <td class="text-right">
                {{
                  !materializedData.refunded_date_time
                    ? currFormat(materializedData.taxable_amount)
                    : `-${currFormat(materializedData.taxable_amount)}`
                }}
              </td>
              <td class="text-right">
                {{
                  !materializedData.refunded_date_time
                    ? currFormat(materializedData.tax_amount)
                    : `-${currFormat(materializedData.tax_amount)}`
                }}
              </td>
              <td class="text-right">
                {{
                  !materializedData.refunded_date_time
                    ? currFormat(materializedData.total_amount)
                    : `-${currFormat(materializedData.total_amount)}`
                }}
              </td>
              <td class="text-left">{{materializedData.ird_sync_status == 'Y' ? 'YES': 'NO'}}</td>
              <td class="text-right">1</td>
              <td class="text-right">
                {{ materializedData.refunded_date_time ? 0 : 1 }}
              </td>
              <td class="text-left">Yes</td>
              <td class="text-left">{{ materializedData.printed_time }}</td>
              <td class="text-left">
                {{
                  materializedData.booking_source_id == 2
                    ? "Self Service"
                    : materializedData.pos_user_name
                }}
              </td>
              <td class="text-left">
                {{
                  materializedData.booking_source_id == 2
                    ? materializedData.cust_name || materializedData.guest_name
                      ? materializedData.guest_name
                      : "-"
                    : materializedData.pos_user_name
                }}
              </td>
              <td class="text-right">
                {{ materializedData.t_sb_id || materializedData.ft_id || materializedData.booking_ref }}
              </td>
              <td class="text-left">{{ materializedData.pm_payment_mode }}</td>
              <td class="text-right">0</td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td colspan="5" class="text-left">Total</td>
              <td class="text-right">
                {{ currFormat(grandTotal.amount_total) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.discount_total) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.taxable_amount_total) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.tax_amount_total) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.total_amount_grand_total) }}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="20">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      materializedRecords: [],
      excelFilePath: "",
      nepalMonth: {},
      grandTotal: {},
      disabledDates: {
        from: "",
      },
      searchText: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.fromDate = new Date();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
    fromDate: function (value) {
      this.disabledDates.from = new Date(
        moment(this.fromDate).format("YYYY"),
        parseFloat(moment(this.fromDate).format("MM")),
        1
      );
      this.toDate = moment(this.toDate).isAfter(value, "months")
        ? moment(this.fromDate).endOf("month").format("YYYY-MM-DD")
        : this.toDate;
    },
  },
  mounted() {},
  methods: {
    moment,
    removeSRPrefix(billNo) {
      return billNo.replace(/^SR-/, "");
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    // onSearch() {
    //   _.debounce(function() {
    //     this.getMaterializedRecords();
    //   }, 1.5 * 1000);
    // },
    getMaterializedRecords(isExcel) {
      if (isExcel == "N") {
        this.materializedRecords = [];
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        searchText: "",
        isExcel,
      };
      ReportsService.getMaterializedReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.materializedRecords = [...data.Records];
            this.grandTotal = { ...data.grandTotal };
            this.nepalMonth = { ...data.nepalMonth };
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/materializedReport.vue